<style lang="scss" scoped>
@import "/src/styles/scss/_variables.scss";
@import "./input-field.scss";
</style>

<template>
  <div
    :class="`slk-g-input-field slk-input-field-v-${validationError || errorMessageOTPEnabled ? 'error' : variant} ${
      variant == 'disabled' ? 'disabled' : ''
    } ${variant == 'display' ? 'display' : ''}`"
    :style="`width: ${inputWidth}`"
  >
    <div class="input-wrap" :class="{ 'disabled-view': disabledView }">
      <PrefixComponent
        :hasPrefix="hasPrefix"
        :variant="variant"
        :inputType="inputType"
        :hasIcon="hasIcon"
        :icon="icon"
        :controlIcon="controlIcon"
        :prefixLabel="prefixLabel"
        :isControlListVisible="isControlListVisible"
        :phoneCodeList="phoneCodeList"
        :selectedPhoneCode="selectedPhoneCode"
        @toggleControlList="toggleControlList"
        @onSelectPhoneCode="onSelectPhoneCode"
      />
      <div class="field-wrap">
        <input
          :type="inputType == 'phone' ? 'number' : inputType"
          v-model="value"
          :required="isRequired"
          @input="handleInput"
          @focus="handleFocus"
          @blur="handleBlur"
          :placeholder="inputLabel"
          :disabled="variant == 'disabled' || variant == 'display' ? true : false"
        />
        <div class="input-label">{{ inputLabel }}</div>
      </div>
      <SuffixComponent
        :hasSuffix="hasSuffix"
        :variant="variant"
        :suffixLabel="suffixLabel"
        :hasIcon="hasIcon"
        :icon="icon"
      />
    </div>
    <div class="helper" v-if="isStorybookView && isHelperVisible" v-html="helperMessage"></div>
    <div class="helper" v-if="!isStorybookView && isHelperVisible && validationError">
      {{ validationError || passwordError }}
    </div>
    <div class="helper" v-if="!isStorybookView && isHelperVisible && errorMessageOTPEnabled">
      Please provide a number
    </div>
  </div>
</template>

<script>
import PrefixComponent from "../input-field-prefix/prefixView.vue";
import SuffixComponent from "../input-field-suffix/suffixView.vue";

export default {
  name: "input-field-view",
  props: {
    variant: { type: String, default: "default" },
    inputType: { type: String, default: "text" },
    inputLabel: { type: String },
    value: { type: String },
    hasIcon: { type: Boolean },
    icon: { type: String },
    hasControl: { type: Boolean },
    controlIcon: { type: String },
    inputWidth: { type: String },
    isHelperVisible: { type: Boolean },
    helperMessage: { type: String },
    isRequired: { type: Boolean },
    rules: { type: Array },
    passwordError: { type: String },
    hasPrefix: { type: Boolean },
    prefixLabel: { type: String },
    hasSuffix: { type: Boolean },
    suffixLabel: { type: String },
    isControlListVisible: { type: Boolean, default: false },
    isStorybookView: { type: Boolean },
    // Phone Type
    isTwoFactorAuthEnabledInConfig: { type: Boolean },
    isPhoneFocused: { type: String },
    phoneCodeSelect: { type: Object },
    phoneCodeList: { type: Array, default: ["Sample item 1", "Sample item 2"] },
    onFocusPhoneNumber: { type: Function },
    validateTwoFactorAuth: { type: Function },
    errorMessageOTPEnabled: { type: Boolean },
    selectedPhoneCode: { type: String },
    disabledView: { type: Boolean, default: false },
    validateWhenTabOut: { type: Boolean, default: false },
  },
  components: {
    PrefixComponent,
    SuffixComponent,
  },
  data() {
    return {
      validationError: "",
      isControlListVisible: false,
    };
  },
  methods: {
    handleInput(event, isForInfoClearing = false) {
      this.validationError = "";
      const inputValue = event.target.value;
      this.$emit("input", inputValue);

      if (!this.isStorybookView && !isForInfoClearing && !this.validateWhenTabOut) {
        this.validateInput(event);
      }
    },
    handleFocus() {
      this.variant = "active";
      this.$emit("focus");
    },
    handleBlur(event) {
      this.variant = "default";
      if (!this.isStorybookView && this.validateWhenTabOut) {
        this.validateInput(event);
      }
    },
    validateInput(event) {
      const inputValue = event.target.value;
      for (const rule of this.rules) {
        const result = rule(inputValue);
        if (result !== true) {
          this.validationError = result;
          return;
        }
      }
    },
    toggleControlList() {
      this.isControlListVisible = !this.isControlListVisible;
    },
    onSelectPhoneCode(item) {
      const updatedPhoneCodeSelect = {
        phoneCode: item.phoneCode,
        country: item.country, // Set the corresponding country based on your logic
      };
      this.$emit("update:phoneCodeSelect", updatedPhoneCodeSelect);
      this.selectedPhoneCode = `+${item.phoneCode}`;
      this.isControlListVisible = false;
    },
    setValidationErrorMessage(errorMessage) {
      this.validationError = errorMessage;
    },
  },
};
</script>
